.imageSample {
  border-radius: 100%;
  width: 24px;
  height: 24px;
  margin: 4px;
  position: relative;
  background-size: cover;
}
